// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* CSS Variables do not work in IE, so we use explicit values here */\n\n.r52PP {\n  font-size: 26px;\n  font-family: var(--font-family-base);\n  color: #202020;\n  padding: 16px 0;\n}\n\n.eYlpr {\n  padding: 16px;\n  font-size: 16px;\n  font-family: var(--font-family-body);\n  color: #363636;\n}\n\n.yG0Qw {\n  color: #6a9b16;\n  font-weight: 600;\n}\n\n.yG0Qw:hover {\n  color: #6a9b16;\n  text-decoration: underline;\n}\n\n._8hMX\\+ {\n  border: 2px solid #6a9b16;\n  border-radius: 16px;\n  background-color: #6a9b16;\n  color: white;\n  padding: 4px 8px;\n  text-align: center;\n  display: block;\n  margin: 16px auto 0;\n  max-width: 128px;\n}\n\n._8hMX\\+:hover,\n._8hMX\\+:focus {\n  color: white;\n  text-decoration: none;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "r52PP",
	"container": "eYlpr",
	"link": "yG0Qw",
	"actionButton": "_8hMX+"
};
export default ___CSS_LOADER_EXPORT___;
